import React, { useEffect, useState } from "react";
import Logo from "../logo.png";
import mainProducts from "../mainProducts.json";
import { NavLink } from 'react-router-dom';

const Header = () => {
  const [isFixed, setIsFixed] = useState(false);
  const [isHide, setIsHide] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsFixed(scrollY > 100); // add 'fixed' if scrollY > 100px
      setIsHide(scrollY > 50); // add 'fixed' if scrollY > 100px
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="main-header">
      <div className="container-fluidp px-0 wow fadeIn">
        <div
          className={`top-bar row gx-0 align-items-center d-lg-flex ${
            isHide ? "hidden slide-up" : "slide-down"
          }`}
        >
          <div className="col-12 col-lg-6 px-1 px-md-5 text-center text-lg-start">
            {/* <small className="d-none d-md-inline-block">
              <i className="fa fa-map-marker-alt me-2"></i>C-610, Vipul Plaza,
              Sector 81, Faridabad, HR, India
            </small> */}
            <small className="ms-2 ms-md-4">
              <a className="text-theme-light" Using target="_blank" without rel="noreferrer" href="mailto:info@dewwbotanicals.com"><i className="fa fa-envelope me-2"></i>info@dewwbotanicals.com</a>
            </small>
          </div>
          <div className="col-12 col-lg-6 px-5 text-end d-none d-lg-block">
            <small>Follow us:</small>
            <a className="text-body ms-3" Using target="_blank" without rel="noreferrer" href="https://www.linkedin.com/company/dewwbotanicals/">
              <i className="fab fa-linkedin-in text-theme-light"></i>
            </a>
            <a className="text-body ms-3" Using target="_blank" without rel="noreferrer" href="https://www.instagram.com/deww_botanicals/">
              <i className="fab fa-instagram text-theme-light"></i>
            </a>
            <a className="text-body ms-3" Using target="_blank" without rel="noreferrer" href="https://www.youtube.com/@DewwBotanicals">
              <i className="fab fa-youtube text-theme-light"></i>
            </a>
          </div>
        </div>

        <nav
          className={`navbar navbar-expand-lg navbar-transparent py-lg-0 px-lg-5 ${
            isFixed ? "fixed slide-down" : ""
          }`}
        >
          <NavLink to="/" className="navbar-brand ms-4 ms-lg-0">
            <h1 className="fw-bold text-primary m-0">
              <img src={Logo} alt="Deww Botanicals" className="logo-img" />
            </h1>
          </NavLink>

          <div className="navbar-menu ms-auto p-4 p-lg-0 justify-lg-content-end">
            <NavLink to="/" className="nav-item nav-link" activeclassname="active">
              Home
            </NavLink>
            {/* <NavLink to="/about" className="nav-item nav-link" activeclassname="active">
              About Us
            </NavLink> */}
            {/* <NavLink to="/products" className="nav-item nav-link" activeclassname="active">
                Products
              </NavLink> */}
              <li className="nav-item dropdown">
              <a
                Using target="_blank" without rel="noreferrer" href="#"
                className="nav-item nav-link dropdown-toggle"
                id="navbarDropdownAbout"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                About Us
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdownAbout">
                    <li>
                      <NavLink to="/about" className="dropdown-item" activeclassname="active">
                         Who We Are?
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/certifications" className="dropdown-item" activeclassname="active">
                         Certifications
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/logistic_support" className="dropdown-item" activeclassname="active">
                         Logistic Support
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/testing_facilities" className="dropdown-item" activeclassname="active">
                         Testing Facilities
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/sourcing" className="dropdown-item" activeclassname="active">
                         Sourcing of Oils
                      </NavLink>
                    </li>
              </ul>
            </li>
            <li className="nav-item dropdown">
              <a
                Using target="_blank" without rel="noreferrer" href="#"
                className="nav-item nav-link dropdown-toggle"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Products
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                <li>
                      <NavLink to="/products" className="dropdown-item" activeclassname="active">
                         View All Products
                      </NavLink>
                    </li>
                {mainProducts.map((oil, index) => {
                  return (
                    <li key={index}>
                      <NavLink to={oil.link} className="dropdown-item" activeclassname="active">
                         {oil.name}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            </li>
            <NavLink to="/contact" className="nav-item nav-link" activeclassname="active">
              Contact Us
            </NavLink>
            {/* <NavLink to="" className="nav-item nav-link" activeclassname="active">
              Our Blogs
            </NavLink> */}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
